import { useContext } from 'react';
import * as R from 'ramda';

import WorkUsers from '@atom/components/common/workUsers/WorkUsers';
import WorkOrderPreviewContext from '@atom/components/workOrderPreview/WorkOrderPreviewContext';
import { Task } from '@atom/types/task';
import { setDisplayDate } from '@atom/utilities/timeUtilities';
import { showWorkDateTime } from '@atom/utilities/workPreferenceUtilities';

import CollapsedTaskHeader from './CollapsedTaskHeader';

import classes from './collapsedTask.module.css';

interface Props {
  task: Task;
}

const CollapsedTask = ({ task }: Props) => {
  const { workOrderDetail } = useContext(WorkOrderPreviewContext);

  const dateFormat = showWorkDateTime(workOrderDetail)
    ? 'MM/dd/yyyy hh:mm a'
    : 'MM/dd/yyyy';

  return (
    <div className={classes.collapsedRow}>
      <CollapsedTaskHeader task={task} />
      <div className={classes.usersSection}>
        {R.isEmpty(task.users) ? (
          <div className={classes.noAssigneesMessage}>No Assignees</div>
        ) : (
          <WorkUsers
            users={task.users as any}
            userGroups={task.userGroups as any}
            avatarSize={32}
            showTaskUserStatus
          />
        )}
      </div>
      <div className={classes.taskDates}>
        <div>{`Due Date: ${setDisplayDate(task.dueDate, dateFormat)}`}</div>
        <div className={classes.dateSpacer}>&bull;</div>
        <div>{`Completion Date: ${setDisplayDate(
          task.completionDate,
          dateFormat,
        )}`}</div>
      </div>
    </div>
  );
};

export default CollapsedTask;
